import axios from '@/axios.js'
export default {
  fetchDiscount: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get('sales-and-purchase/drcc/discounts')
        .then((res) => {
          commit('FETCH_DISCOUNT', res.data.data)
          resolve()
        })
        .catch(err => reject(err))
    })
  },
  fetchDiscountByID: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`sales-and-purchase/drcc/discount/${id}`)
        .then((res) => {
          resolve(res.data.data)
        })
        .catch(err => reject(err))
    })
  },
  addDiscount: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post('sales-and-purchase/drcc/discount', payload)
        .then((res) => {
          resolve(res.data.data)
        })
        .catch(err => reject(err))
    })
  },
  editDiscount: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`sales-and-purchase/drcc/discount/${payload.id}`, payload)
        .then((res) => {
          resolve(res.data.data)
        })
        .catch(err => reject(err))
    })
  },
  deleteDiscount: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete('sales-and-purchase/drcc/discount/' + id)
        .then((res) => {
          resolve(res.data.data)
        })
        .catch(err => reject(err))
    })
  },
  getGeneralDiscount: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get('sales-and-purchase/drcc/general-discount')
        .then((res) => {
          commit('SET_GENERAL_DISCOUNT', res.data.data)
          resolve(res.data.data)
        })
        .catch(err => reject(err))
    })
  },
  getDiscountForEkioskEdit: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios.get('sales-and-purchase/drcc/discounts').then((res) => {
        commit('SET_DISCOUNT_FOR_EKIOSK_EDIT', res.data.data)
        resolve(res.data.data)
      })
    })
  },
  discountApprovalProcess: ({ commit }, payload) => {
    //payload should be {approvalToken: token, status: status}
    return new Promise((resolve, reject) => {
      axios
        .put('sales-and-purchase/discount/process', payload)
        .then((res) => {
          resolve(res.data.data)
        })
        .catch(err => reject(err))
    })
  }
}